export const is = {
    set(obj) {
        return obj != undefined;
    },
    empty(obj) {
        if (obj === null || obj === undefined) {
            return true;
        }
        if (typeof obj === 'string' || Array.isArray(obj)) {
            return obj.length === 0;
        }
        if (typeof obj === 'object') {
            return Object.keys(obj).length === 0;
        }
        return false;
    },
    string(obj) {
        return typeof obj === 'string' || obj instanceof String;
    },
    bool(obj) {
        return typeof obj === 'boolean' || obj instanceof Boolean;
    },
    number(obj) {
        return !isNaN(obj);
    },
    int(obj) {
        return Number.isSafeInteger(obj);
    },
    float(obj) {
        return Number(obj) === obj && obj % 1 !== 0;
    },
    array(obj) {
        return Array.isArray(obj);
    },
    object(obj) {
        if (typeof obj === 'object' &&
            !Array.isArray(obj) &&
            obj !== null) {
            return true;
        }
        else {
            return false;
        }
    },
    iterable(obj) {
        if (obj === null || obj === undefined) {
            return false;
        }
        return typeof obj[Symbol.iterator] === 'function';
    },
    node(obj) {
        return (typeof Node === "object" ? obj instanceof Node :
            obj && typeof obj === "object" && typeof obj.nodeType === "number" && typeof obj.nodeName === "string");
    },
    element(obj) {
        return (typeof HTMLElement === "object" ? obj instanceof HTMLElement :
            obj && typeof obj === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string");
    },
    function(obj) {
        return typeof obj === 'function';
    },
    validKey(obj) {
        return is.string(obj) || is.int(obj);
    }
};
